import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Capabilities from "./sections/Capabilities";
import Specialization from "./sections/Specialization";
import Growth from "./sections/Growth";
import Showcase from "./sections/Showcase";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Capabilities />
      <Specialization />
      <Showcase />
      <Growth />
      <Footer />
    </div>;
}